module.exports = __webpack_public_path__ + "static/media/population.77528f5e.svg";